import React from "react";

/**
 * StagingBanner — tunn färgad topplist som markerar staging-miljön.
 *
 * Byggtidsflagga: renderas endast när frontend byggts med REACT_APP_ENV=staging
 * (staging-bygget). Prod-bygget sätter inte flaggan → komponenten returnerar null,
 * så prod får aldrig någon banner. Ingen runtime-logik, bara ett villkorat UI-element.
 *
 * Overlay (position: fixed + pointer-events: none) så den varken reflowar det
 * karttunga layouten eller blockerar klick under sig.
 */
const StagingBanner = () => {
  if (process.env.REACT_APP_ENV !== "staging") return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: "24px",
        lineHeight: "24px",
        background: "#d4380d",
        color: "#fff",
        textAlign: "center",
        fontWeight: 700,
        fontSize: "12px",
        letterSpacing: "0.15em",
        zIndex: 2147483647,
        pointerEvents: "none",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.4)",
      }}
    >
      STAGING – testmiljö
    </div>
  );
};

export default StagingBanner;
